import { Auth } from "aws-amplify";
import { toast } from "react-toastify";
import React, { useState } from "react";
import { Source } from "@mui/icons-material";
import { Box, Button, Typography, Alert } from "@mui/material";

function VerifyEmail({ formData, setActiveStep, activeStep }) {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsloading] = React.useState(false);

  const handleConfirm = async () => {
    if (!code) {
      setError("Please enter the confirmation code.");
      return;
    }
    setIsloading(true);
    try {
      setError("");
      const res = await Auth.confirmSignUp(formData.mail, code);
      if (res === "SUCCESS") {
        setIsloading(false);
        setActiveStep(activeStep + 1);
        toast.success("Email Verified Successfully");
      }
    } catch (err) {
      setIsloading(false);
      setError(err.message || "Something went wrong. Try again.");
    }
  };

  return (
    <Box sx={{ width: "50%", margin: "0 auto", textAlign: "center" }}>
      <img src="/img/mini_logo.png" alt="" />
      <Typography
        sx={{
          fontWeight: "500",
          fontSize: "20px",
          color: "#282828",
          mt: "48px",
          mb: "12px",
        }}
      >
        Congratulations, {formData.name}!
      </Typography>
      <Typography
        sx={{
          fontSize: "12px",
          color: "#282828",
          marginBottom: "44px",
        }}
      >
        You have completed registration. Please Verify your email.
      </Typography>

      <Box sx={{ position: "relative", marginBottom: "10px" }}>
        <Source
          color="primary"
          sx={{
            position: "absolute",
            top: "5px",
            left: "12px",
          }}
        />
        <input
          className="text_input"
          type="text"
          placeholder="Enter Confirmation Code"
          onChange={(e) => {
            setError("");
            setCode(e.target.value);
          }}
          value={code}
          required
          style={{
            width: "100%",
            padding: "10px 40px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            fontSize: "16px",
          }}
        />
      </Box>

      {error && (
        <Alert severity="error" sx={{ mt: 1, mb: 2 }}>
          {error}
        </Alert>
      )}

      <Box sx={{ maxWidth: "400px", margin: "0 auto" }}>
        <Button
          size="large"
          variant="contained"
          fullWidth
          onClick={handleConfirm}
          sx={{
            mt: 3,
            ml: 1,
            borderRadius: "8px",
          }}
          disabled={isLoading}
        >
          Confirm
        </Button>
      </Box>
    </Box>
  );
}

export default VerifyEmail;
